module.exports = __webpack_public_path__ + "media/images/powerpoint/media/sample-ccee0c22af62d6fc02a6aa0d294f8c23.png";